import { List } from 'antd';

import styled from '@emotion/styled';

export const Container = styled.div`
  .ui-collapse {
    .ui-collapse-header {
      align-items: center;

      .ui-typography {
        margin-bottom: 0;
      }
    }
  }

  .ui-descriptions {
    .ui-descriptions-item-label {
      color: ${({ theme }) => theme.colors.grayDark};
      font-weight: 600;
    }

    th.ui-descriptions-item {
      padding-bottom: 8px;
    }

    td.ui-descriptions-item {
      padding-bottom: 24px;
    }
  }
`;

export const PersonsWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.strokeGrey};
  border-radius: 12px;
  overflow: hidden;
`;

export const PersonItem = styled(List.Item, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected: boolean }>`
  && {
    background-color: ${({ theme, isSelected }) =>
      isSelected ? theme.colors.bgGray : theme.colors.white};
    cursor: pointer;
    padding: 12px 16px;

    .ui-list-item-meta {
      .ui-list-item-meta-title {
        color: ${({ theme, isSelected }) =>
          isSelected ? theme.colors.primary : theme.colors.black};
      }

      .ui-list-item-meta-avatar {
        svg {
          color: ${({ theme, isSelected }) =>
            isSelected ? theme.colors.primary : theme.colors.grayDark};
        }
      }
    }
  }
`;

export const NoteMessage = styled.div`
  color: rgb(0, 0, 0);
  font-weight: 500;
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f0f5ff;
  border: 1px solid #adc6ff;
  border-radius: 4px;
`;
